// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import { Locale } from 'jsw';
import { protectedDirectoryUserListRoute } from 'routes/protectedDirectoryUserListRoute';

export const protectedDirectoriesRoute = {
    path: 'protected-directories',
    handle: {
        crumb: () => ({
            title: Locale.getSection('components.routes').lmsg('protectedDirectories'),
        }),
        returnUrl: ({ params }) => `/cp/domains/${params.domainId}/protected-directories`,
    },
    children: [
        protectedDirectoryUserListRoute,
    ],
};
